module.exports = __webpack_public_path__ + "dist/assets/9acd47b6c04e3451d587f18a5b44b9c8.svg";